export default __webpack_public_path__ + "static/media/terms.b25d6561.md";